module.exports = __webpack_public_path__ + "img/1-md.b892e64f.jpg";